import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { SmoothScroll } from "@/components/SmoothScroll";
import { SeoManager } from "@/components/SeoManager";
import { AccessibilityWidget } from "@/components/AccessibilityWidget";
import { ChatWidget } from "@/components/ChatWidget";
import { WelcomeWalkthrough } from "@/components/WelcomeWalkthrough";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import SeniorHelp from "@/pages/SeniorHelp";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Glossary from "@/pages/Glossary";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

function AppContent() {
  const location = useLocation();

  // Handle OAuth return BEFORE anything else (session_id in URL fragment).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const bareLayout =
    location.pathname.startsWith("/admin") || location.pathname === "/login";

  return (
    <>
      <SmoothScroll />
      <SeoManager />
      {!bareLayout && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/senior-tech-help" element={<SeniorHelp />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/glossary" element={<Glossary />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      {!bareLayout && <Footer />}
      {!bareLayout && <WelcomeWalkthrough />}
      {!bareLayout && <ChatWidget />}
      <AccessibilityWidget />
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
